import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../../core/modules/shared.module';
import { PromoteUserDialogComponent } from './promote.user.dialog.component';

const routes = [
    {
        path     : 'userpromotedialog',
        component: PromoteUserDialogComponent
    }
];

@NgModule({
    declarations: [
        PromoteUserDialogComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        PromoteUserDialogComponent
    ]
})

export class PromoteUserModule
{
}


// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/users/promote/promote.user.dialog.module.ts